/* generated from backend OpenAPI -- do not edit */
import type { JSONSchema } from 'zod/v4/core';
export const schema = {
  "type": "object",
  "properties": {
    "eventType": {
      "type": "string",
      "enum": [
        "communications.resource.changed"
      ]
    },
    "eventId": {
      "type": "string",
      "minLength": 1
    },
    "tenantId": {
      "type": "string",
      "minLength": 1
    },
    "funnelConversationId": {
      "type": "integer",
      "minimum": 1,
      "maximum": 9007199254740991
    },
    "funnelId": {
      "type": "integer",
      "minimum": 1,
      "maximum": 9007199254740991
    },
    "resourceType": {
      "type": "string",
      "enum": [
        "Message",
        "Conversation",
        "StatusHistory",
        "ChannelSession",
        "Call"
      ]
    },
    "resourceId": {
      "type": "string",
      "minLength": 1
    },
    "occurredAt": {
      "type": "string",
      "format": "date-time",
      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
    }
  },
  "required": [
    "eventType",
    "eventId",
    "tenantId",
    "funnelConversationId",
    "resourceType",
    "resourceId",
    "occurredAt"
  ],
  "additionalProperties": false,
  "x-browser-runtime-schema": true
} satisfies JSONSchema.JSONSchema;
